module.exports = __webpack_public_path__ + "img/hero_2.b6a59b9a.webp";